import React from 'react'
import { AiFillFacebook, AiFillInstagram } from 'react-icons/ai'
import { FaLinkedin } from 'react-icons/fa'

const TopNav = () => {
  return (
    <div className='topnav'>
        <div className="contact_number_for_nav">
            <span className='spacing_paddings'>+2348062723480</span>
        </div>
        <div className="display_flex_for_nav">
            <span className='spacing_padding'>info@wellcleanoilfieldservices</span>
            <span className='spacing_padding'>Km 16, Port Harcourt-Aba Expressway Boskel Road, Port Harcourt, Nigeria</span>
        </div>
        <div className="social_icon_for_top_nav">
          <AiFillFacebook size={23} />
          <AiFillInstagram size={23} />
          <FaLinkedin size={23} />
        </div>
    </div>
  )
}

export default TopNav